import {Divider, ListItemButton, ListItemIcon, ListItemText, Typography} from "@mui/material";
import React from "react";
import {CallbackHandler} from "@lxo-blocks/react";
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import {LxCircularProgress} from "@lxo-blocks/react/LoadingContent/LxCircularProgress";

interface MethodListItemButtonProps {
    text: any
    onClick: CallbackHandler,
    icon: any,
    isSubmitting: boolean,
    disabled: boolean,
}

export default function MethodListItemButton(props: MethodListItemButtonProps) {

    return (
        <>
            <Divider/>
            <ListItemButton sx={{py: 2}}  onClick={() => props.onClick()} alignItems={"center"}
                            disabled={props.disabled}>
                <ListItemIcon sx={{justifyContent: "flex-start"}}>
                    {props.icon}
                </ListItemIcon>
                <ListItemText sx={{mr: 2, ml: -2}}>
                    <Typography className="Title" variant="lxButtonMedium">
                        {props.text}
                    </Typography>
                </ListItemText>
                <ListItemIcon sx={{justifyContent: "flex-end"}}>
                    {props.isSubmitting ? <LxCircularProgress size="small" color={"secondary"} sx={{ml: 4}}/>: <ChevronRightIcon/>}
                </ListItemIcon>
            </ListItemButton>

        </>
    );
}
